module.exports = __webpack_public_path__ + "media/images/playstore_image-7c8912c7.png";